import { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import {fetchSimilar} from "../actions/product";
import {CATALOG_ROUTE, PICTURES_PATH} from "../utils/consts";

const SimilarProducts = () => {
    const dispatch = useDispatch();
    const productFetch = useSelector(state => state.productDetail.product) || {};
    const productSimilar = useSelector(state => state.similarProduct.products) || [];
    const isModalOpen = useSelector(state => state.modal.show);

    const [sizeWindow, setSizeWindow] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        if (productFetch.category && productFetch.id) {
            dispatch(fetchSimilar(productFetch.category, productFetch.id));
        }
    }, [productFetch.category, productFetch.id, dispatch]);

    useEffect(() => {
        document.body.classList.toggle("modal-open", isModalOpen);
    }, [isModalOpen]);

    useEffect(() => {
        const handleResize = () => {
            setSizeWindow({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const showModal = useCallback((product) => {
        dispatch({ type: 'SHOW_MODAL' });
        dispatch({
            type: 'ADD_DATA_TO_MODAL',
            payload: {
                id: product.id,
                title: product.title,
                price: product.price,
                description: product.description,
                img: product.img,
                species: product.species,
                sort: product.sort,
                size: product.size
            }
        });
    }, [dispatch]);

    const PrevArrow = useCallback(({ onClick }) => (
        <button className="slick-arrow prev" onClick={onClick}>
            <FaArrowLeft color="#79a206"/>
        </button>
    ), []);

    const NextArrow = useCallback(({ onClick }) => (
        <button className="slick-arrow next" onClick={onClick}>
            <FaArrowRight color="#79a206"/>
        </button>
    ), []);

    const settings = useMemo(() => ({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: sizeWindow.width < 768 ? 1 : 4,
        slidesToScroll: sizeWindow.width < 768 ? 1 : 4,
        autoplay: false,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />
    }), [sizeWindow.width, PrevArrow, NextArrow]);

    return (
        <section className="product_area related_products">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section_title">
                            <h2>Похожая продукция</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <Slider {...settings}>
                        {productSimilar.map((elem) => (
                            <div key={elem.id} className="col-lg-3">
                                <article className="single_product">
                                    <figure>
                                        <div className="product_thumb">
                                            <NavLink className="primary_img" to={`${CATALOG_ROUTE}/${elem.id}`}>
                                                <img
                                                    src={`${PICTURES_PATH}product/${elem.img.split(';')[0]}`}
                                                    alt={elem.title}
                                                />
                                            </NavLink>
                                            <div className="action_links">
                                                <ul>
                                                    <li className="quick_button">
                                                        <a href="" onClick={(e) => {
                                                            e.preventDefault();
                                                            showModal(elem);
                                                        }} title="Подробнее">
                                                            <i className="icon-eye"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <figcaption className="product_content">
                                            <NavLink to={`${CATALOG_ROUTE}/${elem.id}`}>
                                                <h4 className="product_name">{elem.title}</h4>
                                                <div className="product_sort">{elem.sort}</div>
                                                <div className="product_size">{elem.size}</div>
                                            </NavLink>
                                            <div className="price_box">
                                                <span className="current_price">{elem.price}</span>
                                            </div>
                                        </figcaption>
                                    </figure>
                                </article>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default SimilarProducts;